var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "22",
        height: "14",
        viewBox: "0 0 22 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_1007:11335)" } }, [
        _c("path", {
          attrs: {
            d:
              "M10.9908 0.699922C7.32418 0.634589 3.47419 3.26649 1.06335 5.96382C0.810209 6.2473 0.669922 6.61678 0.669922 6.99992C0.669922 7.38306 0.810209 7.75254 1.06335 8.03602C3.41919 10.6774 7.23251 13.3653 10.9908 13.2999C14.7492 13.2346 18.5533 10.6774 20.9092 8.03602C21.1623 7.75254 21.3026 7.38306 21.3026 6.99992C21.3026 6.61678 21.1623 6.2473 20.9092 5.96382C18.5167 3.26649 14.6575 0.634589 10.9908 0.699922Z",
            stroke: "white",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M14.4284 6.99973C14.4261 7.80718 14.149 8.58887 13.6442 9.21161C13.1394 9.83435 12.4381 10.2596 11.6599 10.415C10.8817 10.5704 10.0747 10.4463 9.37622 10.0638C8.67779 9.68136 8.13119 9.06422 7.82952 8.31747C7.52785 7.57071 7.48976 6.74054 7.72176 5.96841C7.95376 5.19628 8.4415 4.52991 9.10188 4.08283C9.76226 3.63575 10.5544 3.43571 11.3435 3.51659C12.1325 3.59746 12.8697 3.95436 13.4293 4.52648C13.7473 4.85164 13.9993 5.2373 14.1707 5.66171C14.3422 6.08611 14.4297 6.54083 14.4284 6.99973Z",
            stroke: "white",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        }),
        _vm._v(" "),
        _c("rect", {
          attrs: {
            x: "11.5005",
            y: "6.99023",
            width: "4.1404",
            height: "4.1404",
            transform: "rotate(-45 11.5005 6.99023)",
            fill: "#002949"
          }
        })
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_1007:11335" } }, [
          _c("rect", { attrs: { width: "22", height: "14", fill: "white" } })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }